export const COM_RELOAD_USERINFO = 'COM_RELOAD_USERINFO';
export const COM_SET_BREADCRUMB = 'COM_SET_BREADCRUMB';
export const COM_SET_USER_INFO = 'COM_SET_USER_INFO';
export const COM_SET_WEB_BASE_INFO = 'COM_SET_WEB_BASE_INFO';
